module.exports = __webpack_public_path__ + "static/media/40.f150626a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/40.svg
// module id = 410
// module chunks = 14